import { IPackData } from '@app/certificates/packs/packs';
import { PackType } from '@app/certificates/manage/manage';

export const packDataMock: IPackData['items'] = [{
    id: 1,
    packType: PackType.INFINITE,
    name: {
        bg: 'Неограничен',
        en: 'Unlimited'
    },
    count: -1,
    description: {
        bg: 'Пакетът позволява неограничено подписване с вашето удостоверение в рамките на една година',
        en: 'The package allows unlimited signing with your certificate within one year'
    },
    validityPeriod: 12,
    price: 30.00,
    currencyCode: 'BGR',
    picture: 'infinity.png'
},
{
    id: 2,
    packType: PackType.PREPAID,
    name: {
        bg: 'Икономичен',
        en: 'Еconomical'
    },
    count: 10,
    description: {
        bg: 'Пакетът позволява 10 подписвания за периода на валидност на удостоверението',
        en: 'The package allows 10 signatures for the validity period of the certificate'
    },
    validityPeriod: -1,
    price: 3.00,
    currencyCode: 'EUR',
    picture: 'practical.png'
},
{
    id: 3,
    packType: PackType.PREPAID,
    name: {
        bg: 'Практичен',
        en: 'Practical'
    },
    count: 60,
    description: {
        bg: 'Пакетът позволява 60 подписвания за периода на валидност на удостоверението',
        en: 'The package allows 60 signatures for the validity period of the certificate'
    },
    validityPeriod: -1,
    price: 10.00,
    currencyCode: 'BGR',
    picture: 'economical.png'
}];
